<template>
  <fin-my-profile-block intro="Bleibe auf dem Laufenden und werde automatisch informiert."
                        title="Dein Newsletter Abo">
    <v-switch
      v-model="newsletterSubscriptionActive"
      :label="newsletterSubscriptionActive ? 'abonniert' : 'nicht abonniert'"
      class="pl-3"
      hide-details
      @change="subscriptionStatusChanged"
      style="display: inline-block;"
    />
  </fin-my-profile-block>
</template>

<script>
import {API, graphqlOperation} from "@/plugins/finAmplifyModules"
import {updateUserNewsletterSubscription} from "@/js/finMutations"
import {mapGetters} from "vuex"
import FinMyProfileBlock from "@/components/pages/profile/MyProfileBlock"

export default {
  name: 'FinSubscribeToNewsletter',
  components: {FinMyProfileBlock},
  data() {
    return {
      newsletterSubscriptionActive: false,
    }
  },
  computed: {
    ...mapGetters('auth', ['userId', 'userEmail', 'userNewsletterSubscribed']),
  },
  methods: {
    async subscriptionStatusChanged() {
      let newsletterSubscriptionResult = null
      try {
        // newsletterSubscriptionActive true => subscribe to newsletter, newsletterSubscriptionActive false => unsubscribe
        newsletterSubscriptionResult = await API.graphql(graphqlOperation(updateUserNewsletterSubscription,
          {input: {id: this.userId, newsletter: this.newsletterSubscriptionActive}}))

        const toastedMsg = 'Deine ' + (this.newsletterSubscriptionActive ? 'Newsletter-Anmeldung' : 'Newsletter-Abmeldung') + ' wurde erfolgreich durchgeführt.'
        this.$toasted.global.finToast({
          message: toastedMsg,
          type: 'success'
        })

        this.$emit('input', this.newsletterSubscriptionActive)
      } catch (error) {
        console.error("Newsletter: failed to " + (this.newsletterSubscriptionActive ? "subscribe " : " unsubscribe") +
          " user to newsletter", this.userEmail, newsletterSubscriptionResult, error)
        this.newsletterSubscriptionActive = !this.newsletterSubscriptionActive
        const toastedMsg = 'Bei deiner ' + (this.newsletterSubscriptionActive ? "Newsletter-Registrierung" : "Newsletter-Abmeldung") +
          ' trat ein Fehler auf. Lade die Seite erneut und wiederhole die Aktion gegebenenfalls.'
        this.$toasted.global.finToast({
          message: toastedMsg,
          type: 'error'
        })
      }
    }
  },
  mounted() {
    this.newsletterSubscriptionActive = this.userNewsletterSubscribed
  }
}
</script>

<style scoped lang="scss">
.v-input--selection-controls {
  margin-top: 0;
}

::v-deep .theme--light.v-label {
  color: $fin-color-primary-dark !important;
  font-weight: 500 !important;
}
</style>
